<template>
  <section>
    <h3 class="h-title">债权治理服务项目选择</h3> 
    <el-form class="e-form f-b" ref="cForm3" :model="cForm3" label-width="240px"  label-position="left" :rules="setpFormRules3">  
      <el-form-item label="标的债权治理事项信息公示服务" prop="isPublicityService">
        <el-select v-model="cForm3.isPublicityService" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="dict in isOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="资产评价服务" prop="isAssetService">
        <el-select v-model="cForm3.isAssetService" placeholder="请选择" @change="openDialog" style="width: 100%">
          <el-option
            v-for="dict in isOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="资产评价服务周期选择" prop="assetServiceSelectArr">
        <el-select v-model="cForm3.assetServiceSelectArr" multiple placeholder="请选择" style="width: 100%">
          <el-option
            v-for="dict in cycleOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="债务人偿付提示服务" prop="isDebtorTipsService">
        <el-select v-model="cForm3.isDebtorTipsService" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="dict in isOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="治理事项存储服务" prop="isSaveService">
        <el-select v-model="cForm3.isSaveService" placeholder="请选择" disabled style="width: 100%">
          <el-option
            v-for="dict in isOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标的债权项下资金由管理人指定第三方提供结算服务" prop="isSettlementService">
        <el-select v-model="cForm3.isSettlementService" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="dict in isOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>

      <div v-if="cForm3.isSettlementService == '0'">
        <el-form-item label="户名" prop="settlementName" :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
          <el-input v-model="cForm3.settlementName" :maxlength="50" placeholder="请输入<=50文字" />
        </el-form-item>
        <el-form-item label="账号" prop="settlementBank" :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
          <el-input v-model="cForm3.settlementBank" :maxlength="50" placeholder="请输入<=50文字" />
        </el-form-item>
        <el-form-item label="开户行" prop="settlementAccount" :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
          <el-input v-model="cForm3.settlementAccount" :maxlength="50" placeholder="请输入<=50文字" />
        </el-form-item>
      </div>
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">		
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>

<script>
import { elFormErrorScrollIntoView } from '@/utils/util'
export default {
    name: "step3",
    props: ["active"],
		data() {
			return {     
        cForm3: {}, 
				setpFormRules3: {
          isPublicityService: [
							{ required: true, message: '请选择', trigger: 'change' }
          ],
          isAssetService: [
							{ required: true, message: '请选择', trigger: 'change' }
          ],
          assetServiceSelectArr: [
							{ required: true, message: '请选择', trigger: 'change' }
          ],
          isDebtorTipsService: [
							{ required: true, message: '请选择', trigger: 'change' }
          ],
          isSaveService: [
							{ required: true, message: '请选择', trigger: 'change' }
          ],
          isSettlementService: [
							{ required: true, message: '请选择', trigger: 'change' }
          ]
        },
        butLoading: false,
        sceneTypeText: '',
        cycleOptions: [],
        isOptions: []
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 3) {
          window.scrollTo(0,0);
          this.$api.api.getDicts("service_cycle").then(response => {
              this.cycleOptions = response.data;
          });
          this.$api.api.getDicts("is_not").then(response => {
            this.isOptions = response.data;
          });
          this.cForm3 = JSON.parse(sessionStorage.setpForm);
          this.$set(this.cForm3, 'isSaveService', '0')
          if(this.cForm3.assetServiceSelect){
            this.$set(this.cForm3, 'assetServiceSelectArr', this.cForm3.assetServiceSelect.split(","))
          }        
        } 
      }
    },
    methods: { 
      openDialog(){
        if(this.cForm3.isAssetService == '0'){
          this.$alert('<div><p>1、报告生成时间为委托人，依据要求提供债务人及增信方（或有），报告期对应财务数据资料日后的7个工作日内生成）；</p><p>2、如委托人未能在评价期后2个月内提供上述材料，或提供材料不符合要求，则视为放弃本项服务内容。</p></div>', '注意', {
            dangerouslyUseHTMLString: true
          });
        }        
      },
      cSubmitForm(type) {
        if(this.cForm3.assetServiceSelectArr){
          this.cForm3.assetServiceSelect = this.cForm3.assetServiceSelectArr.join(',')
        }
        if(type == '0'){
          this.butLoading = true;
          this.cForm3.status = '0'
          this.$api.creditorsRights.addAndUpd(JSON.stringify(this.cForm3)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("保存成功");
              this.$router.go(-1);
            }     
          });
        }else{
          // 文件必填校验
          this.$refs["cForm3"].validate((valid) => {
            if ( valid ) {  
              sessionStorage.setpForm = JSON.stringify(this.cForm3);
              this.$emit('next');
            }else {
              this.$nextTick(() => {
                elFormErrorScrollIntoView()
              })
            }
          })    
        }          
      },
      prev() {
        sessionStorage.setpForm = JSON.stringify(this.cForm3);
        this.$emit('prev')
      }
    }
	}
</script>